const getInterestValue = (interest) => {
  const { value, iconName, iconType } = interest;
  return `${value}_${iconName}_${iconType}`;
};

export default getInterestValue;
